import { render, staticRenderFns } from "./bidListMgmt.vue?vue&type=template&id=33196bda&scoped=true"
import script from "./bidListMgmt.vue?vue&type=script&lang=js"
export * from "./bidListMgmt.vue?vue&type=script&lang=js"
import style0 from "./bidListMgmt.vue?vue&type=style&index=0&id=33196bda&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33196bda",
  null
  
)

export default component.exports